import { formatISO } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface State {
    date: string
}

interface Actions {
    setDate: (date: Date) => void
}

export const useDateStore = create<State & Actions>()(
    persist(
        (set) => ({
            date: formatISO(new Date()),
            setDate: (date: Date) => {
                const formattedDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))

                set({
                    date: formatInTimeZone(formattedDate, 'UTC', "yyyy-MM-dd'T'HH:mm:ss"),
                })
            },
        }),
        {
            name: 'date-storage',
        }
    )
)
